<template>
  <!-- <div class="object-info-card" :style="{'max-height': expandCard ? '100%' : height, 'height': expandCard ? '100%' : height}"> -->

  <div class="object-info-card" :style="{'max-height': height, 'height': height}">
    <div class="card-header">
      <div class="card-title">
        <slot name="before-title-slot" />
        <div v-if="!editingData">
          <slot name="object-image-slot" />
          <span v-if="identifierLabel" class="title-label">{{ identifierLabel }}:</span>
          <span class="title-reference">{{ identifier }}</span>
        </div>
        <span v-if="editingData" class="title-label">{{ $t(cardLabel) }}</span>
      </div>

      <div class="buttons-container">
        <slot name="buttons-before-edit-slot"/>

        <custom-button
          v-if="showEditButton"
          :icon="'mdi-pencil'"
          :icon-size="13"
          :icon-color="editingData ? 'var(--app-primary-base)' : '#FFFFFF'"
          :button-color="editingData ? '#FFFFFF' : 'var(--app-primary-base)'"
          :height="'20px'"
          :width="'20px'"
          :button-styling="buttonStyling"
          @buttonClick="$emit('toggle-edit')"
        />

        <slot name="buttons-after-edit-slot"/>
      </div>
    </div>
    <div class="card-info" :style="{ 'overflow-y': 'visible' }">
      <slot name="before-fields-slot" />
      <div
        v-for="field in fields"
        class="card-info-item-container"
        :key="field.label"
        :style="[{ width: field.size ? field.size : 100 / 3 + '%', overflow: editingData ? 'visible' : 'hidden' }]"
      >
        <v-icon v-if="!editingData">{{ field.icon }}</v-icon>
        <div class="card-info-item" :style="cardInfoItemStyling">
          <input-field v-if="editingData" :key="field.varName" :input-type="field.inputType" :value="field.value"
            :label="field.label" :treeSelectPlaceHolder="field.placeholder ? field.placeholder : null" :input-disabled="field.disabled" :select-options-list="field.options" :disableBranchNodes="field.disableBranchNodes"
            :checkbox-options="field.checkboxOptions" :min="field.min" :max="field.max" :step="field.step" :size="'large'"
            :clearable="field.clearable" :required="field.required" :inputFieldContainerStyling="{ 'padding': '0' }"
            :radioOptions="field.inputType === 'radio' ? field.radioOptions : null" @input="updateField($event, field)"
            :validationObject="field.validation ? field.validation : null"
          />
          <span v-if="!editingData && field.varName !== 'sm_reference'" class="card-info-item-label">
            {{ field.label }}:&nbsp;
          </span>
          <img v-if="!editingData && fieldIsBarcodeField(field.label)" src="../../assets/barcode.png" :alt="field.value">
          <span
            v-if="!editingData && field.varName !== 'sm_reference'"
            class="card-info-item-value">
            {{ Array.isArray(field.value) ? field.value[0].name : field.value }}
          </span>
        </div>
      </div>
    </div>
    <div v-if="editingData && showEditActionButtons" class="action-buttons">
      <custom-button v-if="isWorkspaceObject"
        icon="mdi-eye"
        :height="'26px'"
        :iconSize="12"
        :width="'135px'"
        :buttonStyling="actionButtonsStyling"
        :label="$t('ViewAllWorkspaces')"
        @buttonClick="signalShowAllWorkspaces"
      />
      <custom-button
        :label="$t('Cancel')"
        :button-color="'#FFF'"
        :label-color="'var(--app-primary-base)'"
        :button-styling="actionButtonsStylingCancel"
        @buttonClick="$emit('cancel-edit')"
      />
      <custom-button
        :label="$t(submitButtonLabel)"
        :button-color="'var(--app-primary-base)'"
        :label-color="'#FFF'"
        :button-styling="actionButtonsStylingSave"
        :disabled="!requiredFieldsFilled"
        @buttonClick="$emit('save-object')"
      />
    </div>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import CustomButton from '../_Atoms/CustomButton'
import InputField from "@/newComponents/_Atoms/InputField.vue";
import _ from 'lodash';

export default {
  name: "ObjectMainInfo",

  components: {
    CustomButton,
    InputField,
  },

  props: {
    fields: {
      type: Array,
      required: true,
    },

    editingData: {
      type: Boolean,
    },

    showEditButton: {
      type: Boolean,
    },

    cardLabel: {
      type: String,
    },

    identifierLabel: {
      type: String,
      required: true,
    },

    identifier: {
      type: String,
      required: true,
    },

    height: {
      type: String,
      default: "50%",
    },

    showEditActionButtons: {
      type: Boolean,
      default: false,
    },

    submitButtonLabel: {
      type: String,
    },

    requiredFieldsFilled: {
      type: Boolean,
      default: true,
    },

    isWorkspaceObject: {
      default: false
    }
    // cardInfoOverflow: {
    //   type:
    // }
  },

  data() {
    return {
      buttonStyling: {
        'padding': '0px',
        'drop-shadow': '0.85px 0.85px 1.75px rgba(0, 0, 0, 0.25)',
        'border-radius': '4px',
        'border': '1px solid var(--app-primary-base)',
      },
      actionButtonsStyling: {
        'border': '1px solid var(--app-primary-base)',
        'border-radius': '7px',
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600',
        'z-index': '2',
      },
      actionButtonsStylingCancel: {
        'border': '1px solid var(--app-primary-base)',
        'border-radius': '7px',
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600',
        'z-index': '2'
      },
      actionButtonsStylingSave: {
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600',
        'z-index': '2',
      },
    }
  },

  mounted() {
    bus.$on("create-new-user", this.creatingUser)
  },

  computed: {
    cardInfoItemStyling() {
      return {
        'width': this.editingData ? '100%' : 'auto',
        'margin': !this.editingData ? '10px 12px 10px 0' : ' 6px 9px 6px 0'
      }
    },

    cardHeight() {
      return 'calc(' + this.height + ' - 8px)';
    }
  },

  methods: {
    fieldIsBarcodeField(label) {
      return label === this.$i18n.t('Barcode')
    },

    signalShowAllWorkspaces() {
      bus.$emit("show-hide-workspaces");
    },

    updateField(event, field) {
      let parsedValue = event;
      switch (field.inputType) {
        case 'radio':
          parsedValue = event === 'True' ? true : false
          break;
        case 'float':
        case 'float_pos':
        case 'number':
        case 'number_pos':
          parsedValue = parseFloat(event)
        case 'integer':
        case 'int_pos':
          parsedValue = parseInt(event)
        default:
          break;
      }
      this.$emit('update-object', { varName: field.varName, value: parsedValue });
    },

  },
}
</script>

<style scoped>
.object-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 17px 21px;
  overflow-y: auto;
  background-color: #fff;
}

.card-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 5px;
}

.title-label {
  color: var(--app-primary-base);
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  text-transform: uppercase;
}

.title-reference {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 11.5px;
  text-transform: uppercase;
}

.card-info-item-container {
  display: flex;
  flex-direction: row;
  gap: 13px;
}

.card-info-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1px;
}

.card-info-item-value,
.card-info-item-label {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 11.5px;
  white-space: nowrap;
}

.card-info-item-value {
  font-weight: 800;
}

.card-info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-height: 87%;
}

.v-icon {
  line-height: 0;
  color: var(--app-primary-base);
  font-size: 15px;
}

::-webkit-scrollbar {
  width: 4px;
}

.buttons-container {
  display: flex;
  flex-direction: row;
  gap: 6px
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
  position: absolute;
  right: 21px;
  bottom: 17px;
}

.card-title {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/_Organisms/ObjectMainInfo.vue